// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu_asideMenu__JSzdl {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 100;
  background-color: #fff;
  transition: max-width 0.3s ease 0s;
  max-width: 5.1875rem;
}
.menu_menuOpen__q6a1S .menu_asideMenu__JSzdl {
  max-width: 23.75rem;
}
.menu_asideMenuBody__rPXfV {
  height: 100%;
  padding: 0.9375rem;
  overflow-x: hidden;
  display: flex;
  direction: rtl;
  border-right: 1px solid #e0e0e0;
}
.menu_asideMenuBody__rPXfV::-webkit-scrollbar {
  width: 3px;
}
.menu_asideMenuBody__rPXfV::-webkit-scrollbar-thumb {
  background-color: #119da4;
}
.menu_asideMenuBody__rPXfV::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
}
.menu_asideMenuMenu__1qyMJ {
  flex: 1 1 auto;
}

.menu_menu__Kni0b {
  position: relative;
  z-index: 10;
  direction: ltr;
}
.menu_menuHeader__7RIrP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.9375rem;
  z-index: 2;
  overflow: hidden;
  position: fixed;
  width: 100%;
  background-color: #fff;
  height: 4.0625rem;
  top: 0;
  left: 0;
  border-bottom: 1px solid #e0e0e0;
  transition: max-width 0.3s ease 0s;
}
.menu_menuLogoIbg__4HEcc {
  width: 2.0625rem;
  height: 2.0625rem;
  display: flex;
  align-items: center;
  position: relative;
  object-fit: contain;
  top: 0;
  left: 0;
  transition: all 0.3s ease 0s;
}
.menu_menuOpen__q6a1S .menu_menuLogoIbg__4HEcc {
  left: 110px;
}
.menu_menuNav__6TdRK {
  padding-top: 2.8125rem;
}
.menu_menuList__2kEgR:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}
.menu_menuItems__oTJXj {
  position: relative;
  padding: 0.9375rem 0;
  display: grid;
  gap: 0.3125rem;
  transition: all 0.3s ease 0s;
}
.menu_menuOpen__q6a1S .menu_menuItems__oTJXj {
  padding-top: 60px;
}
.menu_menuTitle__RUusm {
  font-weight: 600;
  line-height: 175%;
  position: absolute;
  width: 100%;
  top: 15px;
  right: -100vw;
  pointer-events: none;
  transition: right 0.3s ease 0s;
  color: #adb5bd;
}
.menu_menuTitle__RUusm:not(:last-child) {
  margin-bottom: 0.625em;
}
.menu_menuOpen__q6a1S .menu_menuTitle__RUusm {
  right: -20px;
}
.menu_menuLink__MH3KV {
  padding: 0.625rem;
  display: flex;
  align-items: center;
  border-radius: 0.25rem;
  line-height: 175%;
  color: #8a92a6;
  transition: all 0.3s ease 0s;
  white-space: nowrap;
  max-width: 3.125rem;
}
.menu_menuOpen__q6a1S .menu_menuLink__MH3KV {
  padding: 0.625rem 1.5rem;
  max-width: 23.75rem;
}
.menu_menuLink__MH3KV span {
  pointer-events: none;
  padding-left: 1.5625rem;
}
@media (any-hover: hover) {
  .menu_menuLink__MH3KV:hover {
    background-color: #f8f8f8;
  }
}
.menu_menuLink__MH3KV.menu__active__iphwy {
  background-color: #007587;
  color: #fff;
}
.menu_menuLink__MH3KV.menu__active__iphwy .menu_menuImageIbg__uJIXe {
  fill: #fff;
}
.menu_menuLink__MH3KV[disabled] {
  cursor: not-allowed;
  background-color: #e9e9e9;
  text-decoration: line-through;
}
.menu_menu__Kni0b [data-disabled-page] {
  background-color: #e9e9e9;
  cursor: not-allowed;
  color: #8a92a6;
}
.menu_menu__Kni0b [data-disabled-page] .menu_menuImageIbg__uJIXe path {
  fill: #8a92a6;
}
.menu_menu__Kni0b [data-disabled-page] span {
  text-decoration: line-through;
}
.menu_menuImageIbg__uJIXe {
  flex-shrink: 0;
  width: 1.875rem;
  height: 1.875rem;
  pointer-events: none;
  fill: #8a92a6;
}

.menu_userHeader__KCKbX {
  position: relative;
  z-index: 150;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.25rem;
}
.menu_userHeaderUsername__YfiUg {
  -webkit-user-select: none;
          user-select: none;
  line-height: 1.25;
  color: #383d3b;
  font-weight: 600;
}
.menu_userHeaderLogout__tE6jt {
  display: flex;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  background-color: #cfebed;
  padding: 0.4375rem;
  transition: all 0.3s ease 0s;
  font-size: 0.75rem;
  line-height: 1.1666666667;
  color: #119da4;
}
.menu_userHeaderLogout__tE6jt svg {
  width: 0.8125rem;
  height: 0.8125rem;
  fill: #007587;
  transition: all 0.3s ease 0s;
}
@media (any-hover: hover) {
  .menu_userHeaderLogout__tE6jt:hover {
    color: #fff;
    background-color: #119da4;
  }
  .menu_userHeaderLogout__tE6jt:hover svg {
    fill: #fff;
  }
}

.menu_iconAsideMenu__oSVjr {
  position: absolute;
  top: 18px;
  right: 0;
  transform: translate(50%, 0) scale(1, 1);
  background-color: #007587;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  width: 1.875rem;
  height: 1.875rem;
  cursor: pointer;
  z-index: 20;
  transition: all 0.3s ease 0s;
}
.menu_iconAsideMenu__oSVjr svg {
  fill: none;
  width: 14px;
  height: 12px;
}
.menu_menuOpen__q6a1S .menu_iconAsideMenu__oSVjr {
  transform: translate(50%, 0) scale(-1, 1);
  background-color: rgba(17, 157, 164, 0.5019607843);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}
@media (any-hover: hover) {
  .menu_iconAsideMenu__oSVjr:hover {
    background-color: rgba(17, 157, 164, 0.5019607843);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/admin/UI/menu/menu.module.scss"],"names":[],"mappings":"AAOA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kCAAA;EACA,oBAVc;AAIhB;AAQE;EACE,mBAdY;AAQhB;AASE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,+BAAA;AAPJ;AAQI;EACE,UAAA;AANN;AAWI;EAGE,yBAAA;AAXN;AAcI;EACE,4CAAA;AAZN;AAuBE;EACE,cAAA;AArBJ;;AA2BA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AAxBF;AA2BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;EACA,gCAAA;EACA,kCAAA;AAzBJ;AA6BE;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,4BAAA;AA3BJ;AA6BI;EAEE,WAAA;AA5BN;AAsCE;EACE,sBAAA;AApCJ;AA6CI;EACE,gCAAA;AA3CN;AAgDE;EACE,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,cAAA;EACA,4BAAA;AA9CJ;AAgDI;EACE,iBAAA;AA9CN;AAuDE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,8BAAA;EACA,cAAA;AArDJ;AAuDI;EACE,sBAAA;AArDN;AAwDI;EACE,YAAA;AAtDN;AA+DE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;AA7DJ;AA+DI;EACE,wBAAA;EACA,mBA7KU;AAgHhB;AAgEI;EACE,oBAAA;EACA,uBAAA;AA9DN;AAiEI;EACE;IACE,yBAAA;EA/DN;AACF;AAkEI;EACE,yBAAA;EACA,WAAA;AAhEN;AAkEM;EACE,UAAA;AAhER;AAqEI;EACE,mBAAA;EACA,yBAAA;EACA,6BAAA;AAnEN;AAuEE;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AArEJ;AAwEM;EACE,aAAA;AAtER;AA0EI;EACE,6BAAA;AAxEN;AA6EE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;AA3EJ;;AAgFA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA7EF;AAgFE;EACE,yBAAA;UAAA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AA9EJ;AAkFE;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,4BAAA;EAEA,kBAAA;EACA,yBAAA;EACA,cAAA;AAjFJ;AAmFI;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,4BAAA;AAjFN;AAoFI;EACE;IACE,WAAA;IACA,yBAAA;EAlFN;EAoFM;IACE,UAAA;EAlFR;AACF;;AA0FA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,wCAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;AAvFF;AAwFE;EACE,UAAA;EACA,WAAA;EACA,YAAA;AAtFJ;AAwFE;EACE,yCAAA;EACA,kDAAA;EACA,yCAAA;AAtFJ;AAyFE;EACE;IACE,kDAAA;EAvFJ;AACF","sourcesContent":["@use 'sass:math';\r\n@import '../../../../assets/scss/mixins';\r\n//========================================================================================================================================================\r\n// Размер бокового меню\r\n$maxWidthAside: rem(380);\r\n$minWidthAside: rem(83);\r\n\r\n.asideMenu {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  z-index: 100;\r\n  background-color: #fff;\r\n  transition: max-width 0.3s ease 0s;\r\n  max-width: $minWidthAside;\r\n\r\n  .menuOpen & {\r\n    max-width: $maxWidthAside;\r\n  }\r\n\r\n  &Body {\r\n    height: 100%;\r\n    padding: rem(15);\r\n    overflow-x: hidden;\r\n    display: flex;\r\n    direction: rtl;\r\n    border-right: 1px solid #e0e0e0;\r\n    &::-webkit-scrollbar {\r\n      width: 3px;\r\n      // background-color: #119DA4;\r\n      // background-color: $mainLightGray;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      // border-radius: 10px;\r\n      // background-color: $mainBlue;\r\n      background-color: #119da4;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);\r\n      // border-radius: 10px;\r\n      // background-color: #119DA4;\r\n    }\r\n\r\n    // &::-webkit-scrollbar {\r\n    // \twidth: 0;\r\n    // }\r\n  }\r\n\r\n  // .aside-menu__menu\r\n  &Menu {\r\n    flex: 1 1 auto;\r\n  }\r\n}\r\n\r\n//========================================================================================================================================================\r\n\r\n.menu {\r\n  position: relative;\r\n  z-index: 10;\r\n  direction: ltr;\r\n\r\n  // .menu__header\r\n  &Header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0 rem(15);\r\n    z-index: 2;\r\n    overflow: hidden;\r\n    position: fixed;\r\n    width: 100%;\r\n    background-color: #fff;\r\n    height: rem(65);\r\n    top: 0;\r\n    left: 0;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    transition: max-width 0.3s ease 0s;\r\n  }\r\n\r\n  // .menu__logo-ibg\r\n  &LogoIbg {\r\n    width: rem(33);\r\n    height: rem(33);\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    object-fit: contain;\r\n    top: 0;\r\n    left: 0;\r\n    transition: all 0.3s ease 0s;\r\n\r\n    .menuOpen & {\r\n      //width: rem(70);\r\n      left: 110px;\r\n      //height: rem(31);\r\n    }\r\n  }\r\n\r\n  // .menu__icon\r\n  &Icon {\r\n  }\r\n\r\n  // .menu__nav\r\n  &Nav {\r\n    padding-top: rem(45);\r\n  }\r\n\r\n  // .menu__body\r\n  &Body {\r\n  }\r\n\r\n  // .menu__list\r\n  &List {\r\n    &:not(:last-child) {\r\n      border-bottom: 1px solid #e0e0e0;\r\n    }\r\n  }\r\n\r\n  // .menu__items\r\n  &Items {\r\n    position: relative;\r\n    padding: rem(15) 0;\r\n    display: grid;\r\n    gap: rem(5);\r\n    transition: all 0.3s ease 0s;\r\n\r\n    .menuOpen & {\r\n      padding-top: 60px;\r\n\r\n      //&Padding {\r\n      //  padding-top: 15px;\r\n      //}\r\n    }\r\n  }\r\n\r\n  // .menu__title\r\n  &Title {\r\n    font-weight: 600;\r\n    line-height: 175%;\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 15px;\r\n    right: -100vw;\r\n    pointer-events: none;\r\n    transition: right 0.3s ease 0s;\r\n    color: #adb5bd;\r\n\r\n    &:not(:last-child) {\r\n      margin-bottom: em(10);\r\n    }\r\n\r\n    .menuOpen & {\r\n      right: -20px;\r\n    }\r\n  }\r\n\r\n  // .menu__item\r\n  &Item {\r\n  }\r\n\r\n  // .menu__link\r\n  &Link {\r\n    padding: rem(10);\r\n    display: flex;\r\n    align-items: center;\r\n    border-radius: rem(4);\r\n    line-height: 175%;\r\n    color: #8a92a6;\r\n    transition: all 0.3s ease 0s;\r\n    white-space: nowrap;\r\n    max-width: rem(50);\r\n\r\n    .menuOpen & {\r\n      padding: rem(10) rem(24);\r\n      max-width: $maxWidthAside;\r\n    }\r\n\r\n    span {\r\n      pointer-events: none;\r\n      padding-left: rem(25);\r\n    }\r\n\r\n    @media (any-hover: hover) {\r\n      &:hover {\r\n        background-color: #f8f8f8;\r\n      }\r\n    }\r\n\r\n    &._active {\r\n      background-color: #007587;\r\n      color: #fff;\r\n\r\n      .menuImageIbg {\r\n        fill: #fff;\r\n        path {\r\n        }\r\n      }\r\n    }\r\n    &[disabled] {\r\n      cursor: not-allowed;\r\n      background-color: #e9e9e9;\r\n      text-decoration: line-through;\r\n    }\r\n  }\r\n\r\n  [data-disabled-page] {\r\n    background-color: #e9e9e9;\r\n    cursor: not-allowed;\r\n    color: #8a92a6;\r\n\r\n    .menuImageIbg {\r\n      path {\r\n        fill: #8a92a6;\r\n      }\r\n    }\r\n\r\n    span {\r\n      text-decoration: line-through;\r\n    }\r\n  }\r\n\r\n  // .menu__image-ibg\r\n  &ImageIbg {\r\n    flex-shrink: 0;\r\n    width: rem(30);\r\n    height: rem(30);\r\n    pointer-events: none;\r\n    fill: #8a92a6;\r\n  }\r\n}\r\n//========================================================================================================================================================\r\n\r\n.userHeader {\r\n  position: relative;\r\n  z-index: 150;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: rem(20);\r\n\r\n  // .user-header__username\r\n  &Username {\r\n    user-select: none;\r\n    line-height: math.div(20, 16);\r\n    color: #383d3b;\r\n    font-weight: 600;\r\n  }\r\n\r\n  // .user-header__logout\r\n  &Logout {\r\n    display: flex;\r\n    font-weight: 600;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: rem(10);\r\n    background-color: #cfebed;\r\n    padding: rem(7);\r\n    transition: all 0.3s ease 0s;\r\n\r\n    font-size: rem(12);\r\n    line-height: math.div(14, 12);\r\n    color: #119da4;\r\n\r\n    svg {\r\n      width: rem(13);\r\n      height: rem(13);\r\n      fill: #007587;\r\n      transition: all 0.3s ease 0s;\r\n    }\r\n\r\n    @media (any-hover: hover) {\r\n      &:hover {\r\n        color: #fff;\r\n        background-color: #119da4;\r\n\r\n        svg {\r\n          fill: #fff;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n//========================================================================================================================================================\r\n//Burger\r\n.iconAsideMenu {\r\n  position: absolute;\r\n  top: 18px;\r\n  right: 0;\r\n  transform: translate(50%, 0) scale(1, 1);\r\n  background-color: #007587;\r\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\r\n  border-radius: 50%;\r\n  width: rem(30);\r\n  height: rem(30);\r\n  cursor: pointer;\r\n  z-index: 20;\r\n  transition: all 0.3s ease 0s;\r\n  svg {\r\n    fill: none;\r\n    width: 14px;\r\n    height: 12px;\r\n  }\r\n  .menuOpen & {\r\n    transform: translate(50%, 0) scale(-1, 1);\r\n    background-color: #119da480;\r\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\r\n  }\r\n\r\n  @media (any-hover: hover) {\r\n    &:hover {\r\n      background-color: #119da480;\r\n    }\r\n  }\r\n}\r\n\r\n//====================================================================================================\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"asideMenu": `menu_asideMenu__JSzdl`,
	"menuOpen": `menu_menuOpen__q6a1S`,
	"asideMenuBody": `menu_asideMenuBody__rPXfV`,
	"asideMenuMenu": `menu_asideMenuMenu__1qyMJ`,
	"menu": `menu_menu__Kni0b`,
	"menuHeader": `menu_menuHeader__7RIrP`,
	"menuLogoIbg": `menu_menuLogoIbg__4HEcc`,
	"menuNav": `menu_menuNav__6TdRK`,
	"menuList": `menu_menuList__2kEgR`,
	"menuItems": `menu_menuItems__oTJXj`,
	"menuTitle": `menu_menuTitle__RUusm`,
	"menuLink": `menu_menuLink__MH3KV`,
	"_active": `menu__active__iphwy`,
	"menuImageIbg": `menu_menuImageIbg__uJIXe`,
	"userHeader": `menu_userHeader__KCKbX`,
	"userHeaderUsername": `menu_userHeaderUsername__YfiUg`,
	"userHeaderLogout": `menu_userHeaderLogout__tE6jt`,
	"iconAsideMenu": `menu_iconAsideMenu__oSVjr`
};
export default ___CSS_LOADER_EXPORT___;
